/**
 * @file ga4.js
 * @location src/integrations/ga4.js
 * @role Google Analytics 4 연동 — gtag.js 로드 + analytics.track() 이벤트를 GA4 로 전달.
 *
 *  VITE_GA4_ID(예: G-XXXXXXXXXX) 가 있을 때만 동작. 없으면 noop(개발/미설정 환경).
 *  자동 page_view 는 gtag config 가 처리. 커스텀 이벤트(EVENTS.*)는 analytics 어댑터로 흐른다.
 */
import { registerAnalyticsAdapter } from './analytics.js';

/**
 * GA4 초기화. id 미지정 시 VITE_GA4_ID env 사용.
 * @param {string} [id] GA4 Measurement ID (G-...)
 * @returns {boolean} 초기화 여부
 */
export function initGa4(id = import.meta.env.VITE_GA4_ID) {
  if (!id || typeof document === 'undefined' || typeof window === 'undefined') return false;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id);

  // 기존 track() 호출이 GA4 로도 흐르게 어댑터 등록.
  registerAnalyticsAdapter({
    name: 'ga4',
    track: (event, props) => gtag('event', event, props),
  });
  return true;
}
